import { baseConfig } from '../base.config';
import { mix } from '@oec-seller/sdk/m4b-seller-material';

export const REGION_CONFIG = mix(baseConfig, {
  features: {
    showRegionItem: false,
    defaultRegion: 'US',
    privacyPolicyLink: 'https://seller-us.tiktok.com/university/article/agreement?knowledge_id=10013713&identity=1'
  },
  language: {
    switchLang: ['en']
  }
} as Partial<typeof baseConfig>);
